// AJAX cart quantity update for custom cart page
// Cart item quantity controls with GSAP animations

jQuery(document).ready(function ($) {
    
    // Custom cart quantity controls (plus/minus buttons)
    $(document).on('click', '.cart-qty-plus', function(e) {
        e.preventDefault();
        const $form = $(this).closest('.cart-qty-form');
        const $input = $form.find('.cart-qty-value');
        const max = parseInt($input.attr('max')) || 9999;
        const currentVal = parseInt($input.val()) || 0;
        
        if (currentVal < max) {
            $input.val(currentVal + 1).trigger('change');
        }
    });

    $(document).on('click', '.cart-qty-minus', function(e) {
        e.preventDefault();
        const $form = $(this).closest('.cart-qty-form');
        const $input = $form.find('.cart-qty-value');
        const currentVal = parseInt($input.val()) || 0;
        
        if (currentVal > 0) {
            $input.val(currentVal - 1).trigger('change');
        }
    });

    // Handle quantity change (AJAX update with debounce)
    let qtyUpdateTimeout;
    $(document).on('change input', '.cart-qty-value', function() {
        clearTimeout(qtyUpdateTimeout);
        const $input = $(this);
        const $form = $input.closest('.cart-qty-form');
        const cartItemKey = $form.data('cart-item-key');
        const quantity = parseInt($input.val()) || 0;
        
        
        // Debounce for 300ms (fast response)
        qtyUpdateTimeout = setTimeout(function() {
            updateCartItemQuantity(cartItemKey, quantity, $form);
        }, 300);
    });

    // Handle blur event for manual input
    $(document).on('blur', '.cart-qty-value', function() {
        const $input = $(this);
        const $form = $input.closest('.cart-qty-form');
        const cartItemKey = $form.data('cart-item-key');
        const quantity = parseInt($input.val()) || 0;
        
        clearTimeout(qtyUpdateTimeout);
        updateCartItemQuantity(cartItemKey, quantity, $form);
    });

    // Update cart item quantity via AJAX
    function updateCartItemQuantity(cartItemKey, quantity, $form) {
        
        if (quantity === 0) {
            removeCartItem(cartItemKey, $form);
            return;
        }
    
        const $cartItem = $form.closest('.cart--item');
        $cartItem.addClass('updating');
        console.log('💫 Starting AJAX update for cart item');

        $.ajax({
            type: 'POST',
            url: wc_add_to_cart_params.ajax_url,
            data: {
                action: 'woocommerce_update_cart_item_quantity',
                cart_item_key: cartItemKey,
                quantity: quantity,
                _wpnonce: wc_add_to_cart_params.update_cart_nonce
            },
            success: function(response) {
                if (response.success) {
                    // Update item price
                    $cartItem.find('.cart-item-price').html(response.data.item_price_html);
                    
                    // Update cart total
                    $('.cart-total-price').html(' &bull; ' + response.data.cart_total_html);
                    
                    // Update cart count badge
                    if (response.data.cart_count !== undefined) {
                        const $cartBadge = $('.cart-count-badge');
                        $cartBadge.text(response.data.cart_count);
                        if (response.data.cart_count === 0) {
                            $cartBadge.addClass('hidden');
                        } else {
                            $cartBadge.removeClass('hidden');
                        }
                    }
                    
                    // Trigger header update
                    jQuery(document.body).trigger('updated_cart_totals');
                } else {
                    alert('Error updating cart: ' + (response.data.message || 'Unknown error'));
                }
                $cartItem.removeClass('updating');
            },
            error: function() {
                $cartItem.removeClass('updating');
                alert('Error updating cart. Please try again.');
            }
        });
    }

    // Remove cart item via AJAX with pulsing animation
    function removeCartItem(cartItemKey, $form) {
        console.log('🗑️ removeCartItem called with:', cartItemKey);
        const $cartItem = $form.closest('.cart--item');
        const cartItem = $cartItem[0];
        
        // Add removing class for pulsing animation
        $cartItem.addClass('removing');
        console.log('🔄 Added removing class, starting pulse animation');
        
        // Make AJAX call while pulsing
        removeCartItemAjax(cartItemKey, $cartItem, cartItem);
    }

    // AJAX call to remove cart item with slide animation
    function removeCartItemAjax(cartItemKey, $cartItem, cartItem) {
        $.ajax({
            type: 'POST',
            url: wc_add_to_cart_params.ajax_url,
            data: {
                action: 'woocommerce_update_cart_item_quantity',
                cart_item_key: cartItemKey,
                quantity: 0,
                _wpnonce: wc_add_to_cart_params.update_cart_nonce
            },
            success: function(response) {
                if (response.success) {
                    // Stop pulsing, start slide-out animation
                    $cartItem.removeClass('removing');
                    
                    if (typeof gsap !== 'undefined') {
                        gsap.to(cartItem, {
                            opacity: 0,
                            x: -50,  // Slide left
                            duration: 0.2, // Faster removal animation
                            ease: 'power2.in',
                            onComplete: function() {
                                $cartItem.remove();
                                
                                // Update cart total
                                $('.cart-total-price').html(' &bull; ' + response.data.cart_total_html);
                                
                                // Update cart count badge
                                if (response.data.cart_count !== undefined) {
                                    const $cartBadge = $('.cart-count-badge');
                                    $cartBadge.text(response.data.cart_count);
                                    if (response.data.cart_count === 0) {
                                        $cartBadge.addClass('hidden');
                                    } else {
                                        $cartBadge.removeClass('hidden');
                                    }
                                }
                                
                                // Check if cart is now empty
                                if ($('.cart--item').length === 0) {
                                    showEmptyCart();
                                }
                                
                                // Trigger header update via simple AJAX fragment refresh with timeout
                                jQuery.ajax({
                                    url: woocommerce_params.ajax_url,
                                    type: 'POST',
                                    data: { action: 'woocommerce_get_refreshed_fragments' },
                                    timeout: 3000, // 3 second timeout for faster response
                                    success: function(response) {
                                        if (response && response.fragments) {
                                            jQuery.each(response.fragments, function(key, value) {
                                                jQuery(key).replaceWith(value);
                                            });
                                            jQuery(document.body).trigger('updated_cart_totals', [response.fragments, response.cart_hash]);
                                        }
                                    },
                                    error: function() {
                                        // Fallback: simple page refresh if fragment refresh fails
                                        window.location.reload();
                                    }
                                });
                            }
                        });
                    } else {
                        // Fallback without GSAP
                        $cartItem.fadeOut(200, function() {
                            $cartItem.remove();
                            
                            // Update cart total
                            $('.cart-total-price').html(' &bull; ' + response.data.cart_total_html);
                            
                            // Update cart count badge
                            if (response.data.cart_count !== undefined) {
                                const $cartBadge = $('.cart-count-badge');
                                $cartBadge.text(response.data.cart_count);
                                if (response.data.cart_count === 0) {
                                    $cartBadge.addClass('hidden');
                                } else {
                                    $cartBadge.removeClass('hidden');
                                }
                            }
                            
                            // Check if cart is now empty
                            if ($('.cart--item').length === 0) {
                                showEmptyCart();
                            }
                            
                            // Trigger header update via simple AJAX fragment refresh with timeout
                            jQuery.ajax({
                                url: woocommerce_params.ajax_url,
                                type: 'POST',
                                data: { action: 'woocommerce_get_refreshed_fragments' },
                                timeout: 3000, // 3 second timeout for faster response
                                success: function(response) {
                                    if (response && response.fragments) {
                                        jQuery.each(response.fragments, function(key, value) {
                                            jQuery(key).replaceWith(value);
                                        });
                                        jQuery(document.body).trigger('updated_cart_totals', [response.fragments, response.cart_hash]);
                                    }
                                },
                                error: function() {
                                    // Fallback: simple page refresh if fragment refresh fails
                                    window.location.reload();
                                }
                            });
                        });
                    }
                }
            },
            error: function() {
                $cartItem.removeClass('removing');
                alert('Error removing item. Please try again.');
            }
        });
    }

    // Show empty cart message without page refresh with GSAP animation
    function showEmptyCart() {
        // Hide any WooCommerce notices
        $('.woocommerce-notices-wrapper, .woocommerce-message, .woocommerce-info').fadeOut(300);
        
        // Get the correct theme URL for the SVG icon
        const themeUrl = window.location.origin + '/wp-content/themes/shop-theme/';
        const iconUrl = themeUrl + 'icons/image-cart-empty.svg';
        
        const emptyCartHTML = `
            <div class="max-w-[340px] mx-auto text-center cart-empty-animated">
                <div class="flex justify-center mb-[30px]">
                    <img src="${iconUrl}" alt="Empty cart" width="210" height="97">
                </div>
                <h2 class="text-[30px] lg:text-[42px] leading-[1.1] font-wulkan-display font-semibold text-primary-950/50 mb-[30px]">
                    Your cart is empty
                </h2>
                <div class="button-area">
                    <a href="${wc_add_to_cart_params.shop_url || '/'}" class="btn btn-primary min-w-[240px]">Return to shop</a>
                </div>
            </div>
        `;
        
        // Replace the cart items container
        const $container = $('.cart-wrapper-area');
        $container.html(emptyCartHTML);
        
        // GSAP animation for empty cart message
        const emptyCartEl = $('.cart-empty-animated')[0];
        if (typeof gsap !== 'undefined' && emptyCartEl) {
            gsap.from(emptyCartEl, {
                opacity: 0,
                y: 20,
                duration: 0.4,
                ease: 'power2.out'
            });
      } else {
            // Fallback
            $('.cart-empty-animated').hide().fadeIn(400);
        }
    }
});
